<template>
    <div class="archive-detail">
        <div class="left">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>基本信息</span>
                </div>
                <template>
                    <el-form class="form viewFormWrapper" label-width="175px" style="margin-bottom: 10px">
                        <el-row :span="20">
                            <el-col :span="20">
                                <el-form-item label="标段名称：">
                                    <span>{{ projectInfo.bidSectionName || '-' }}</span>
                                </el-form-item>
                            </el-col>

                        </el-row>
                    </el-form>
                </template>

            </el-card>
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>项目归档目录</span>
                </div>
                <template>
                    <table class="eval_table">
                        <thead>
                        <tr>
                            <th style="width: 500px">
                                归档范围
                            </th>
                            <th style="width: 500px">
                                支持上传类型
                            </th>
                            <th style="width: 700px">
                                归档资料
                            </th>
                        </tr>
                        </thead>
                        <tbody  v-if="projectInfo.configs&&projectInfo.configs.length>0">
                        <template >
                            <tr  v-for="(item,index) in projectInfo.configs" :key="index">
                                <td style="width:200px;text-align: left;padding-left: 16px;height: 42px;">
                                    {{ (index + 1) + '、' + item.name }}
                                </td>
                                <td style="width:200px">
                                    {{ item.fileExts }}
                                </td>
                                <td class="pdf" style="width:500px">
                                    <el-button :key="'idx'+idx" @click="showFileDetail(itm)" class="fileBtnWrapper" v-for="(itm,idx) in item.details">
                                        <icon-svg class="svg-icon" name="pdf"></icon-svg>
                                        <p :title="itm.fileName">{{ itm.fileName || '-' }}</p>
                                    </el-button>
                                </td>
                            </tr>
                        </template>
                        </tbody>
                        <tbody v-else style="line-height: 44px; text-align: center; width: 100%;color: #909399">
                        <tr>
                            <td :colspan="3">
                                暂无数据
                            </td>
                        </tr>

                        </tbody>
                    </table>
                </template>
            </el-card>
        </div>
        <div class="right">
            <el-button type="primary"
                       size="small"
                       :loading="exportLoading"
                       @click="onClickExport"
            >导出</el-button>
            <el-button @click="back()" size="small">返回</el-button>
        </div>
    </div>

</template>

<script>
import {tabsCloseCurrentHandle} from "@/utils/routeTab";

export default {
    data() {
        return {
            projectInfo: {},
            exportLoading: false,
        }
    },
    mounted() {
        this.getDetailData();
    },
    methods: {
        //获取详情数据
        getDetailData() {
            const archiveId = this.$route.query.archiveId;
            this.$http.get(`/nonCustomForm/getArchivesDetail?archiveId=${archiveId}`)
                .then(res => {
                    if(res.data.code === '1') {
                        this.projectInfo = res.data.data
                    }
                });
        },
        //下载
        showFileDetail(data){
            this.$http.get(`/nonCustomForm/upload/archivedownload?id=${data.id}`)
                .then(res => {
                    window.open(res.data)
                });
        },
        //导出
        onClickExport() {
            this.exportLoading = true
            const archiveId = this.$route.query.archiveId;
            this.$http.get(`/nonCustomForm/export?archiveId=${archiveId}`)
                .then(res => {
                    if(res.data.code === '1') {
                        window.open(res.data.data)
                        this.exportLoading = false
                    }else {
                        setTimeout(() => {
                            this.onClickExport()
                        }, 1000 * 30)
                    }
                });
        },
        //返回
        back() {
            tabsCloseCurrentHandle();
            this.$router.push({
                name: 'archive-list',
            })
        },

    }


}
</script>

<style lang="less" scoped>
.eval_table {
    padding: 0;
    margin: 0;
    border: 1px solid #ebeef5;
    border-spacing: 0;
    border-collapse: collapse;
    text-align: center;
    table-layout: fixed;
    word-break: break-all;
    word-wrap: break-word;

    th {
        border: 1px solid #ebeef5;
        padding: 4px 8px;
        background-color: rgb(245, 247, 250);
        margin: 0;
        height: 44px;
        border-spacing: 0;
        border-collapse: collapse;
        color: #909399;
        font-weight: 500;
    }


    td {
        padding: 4px 8px;
        margin: 0;
        border-collapse: collapse;
        border-spacing: 0;
        border: 1px solid #ebeef5;

        p {
            margin: 0;
        }

        span {
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        .el-button {
            border: none;
            padding: 0;
            margin: 0;
            &:hover{
                background: transparent;
            }
        }

    }

    td.pdf{
        width: 500px;
        text-align: left;
    }

    .fileBtnWrapper.el-button{
        margin-right: 16px;
        width:120px;
        p{
            overflow: hidden;
            word-break: break-all;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
    }



}

.archive-detail {
    display: flex;
    flex-direction: row;
    gap: 12px;
    .left {
        flex: 1;
    }
    .right {
        width: 200px;
        height: 200px;
        padding: 24px 12px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        background: #fff;
        display: flex;
        flex-direction: column;
        gap: 12px;
        .el-button+.el-button{
            margin-left: 0;
        }
    }
}
</style>
